<template>
  <div>
    <div style="overflow: hidden">
      <slot name="title"> </slot>
      <span class="btn-group">
        <el-select
          @change="tidal"
          clearable
          size="mini"
          v-model="selectYear"
          v-if="timeType === '年'"
          style="width: 100px;float: left;margin-left: 5px;"
          placeholder="请选择">
        <el-option
          v-for="item in selectYears"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
        <el-button class="datatype" size="mini" @click="explorer" v-if="!dark">导出</el-button>
        <el-radio-group
          v-if="!dark"
          v-model="dataType"
          @change="onDataType"
          size="mini"
          class="datatype"
          fill="#3e7878">
          <el-radio-button label="1">投放</el-radio-button>
          <el-radio-button label="2">入栏</el-radio-button>
          <el-radio-button label="3">活跃</el-radio-button>
          <el-radio-button label="4">调度</el-radio-button>
          <el-radio-button label="5">周转</el-radio-button>
        </el-radio-group>
        <el-radio-group
          @change="onTimeType"
          size="mini"
          v-model="timeType"
          style="margin-left: 16px "
          fill="#3e7878">
          <el-radio-button label="日"></el-radio-button>
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="年"></el-radio-button>
        </el-radio-group>
      </span>
    </div>
    <div id="totalChart" :style="{ height: height + 'px' }"></div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="monthchart"
      :title="dialogTitleMonth"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth">
      <template v-slot:content>
        <div id="monthchart"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="daychart"
      :title="dialogTitleDay"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay">
      <template v-slot:content>
        <div id="daychart"/>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { Line } from '@antv/g2plot'
import WDialog from '@/components/Model/index.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    WDialog
  },
  data() {
    return {
      chartData: [],
      height: 300,
      monthCache: null,
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      timeType: this.getDefaultTimeType(), // 0-日，1-月，2-年
      dataType: '5',
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {},
      // 电单车企业投放量
      brandThrowInData: []
    }
  },
  props: {
    realHeight: {
      type: Number,
      default: 300
    },
    selfAreaId: {
      type: String,
      defalut: ''
    },
    isAggregation: {
      type: [Boolean, String],
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    initTimeType: {
      type: String,
      default: '月'
    },
    // 针对日常值守总量曲线图
    initDataType: {
      type: String,
      default: null
    }
  },
  watch: {
    realHeight(val) {
      if (val) {
        this.getAreaBrandDetails()
        setTimeout(() => {
          this.tidal()
        }, 1000)
      }
    }
  },
  computed: {
    ...mapGetters([
      'userBikeType'
    ]),
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    }
  },
  created() {
    this.getAreaBrandDetails()
    setTimeout(() => {
      this.yearChange()
      // 判断当前时间是否为每月1号，每月1号展示品牌车辆状态统计日的数据
      const today = new Date()
      const isFirstDay = today.getDate() === 1
      this.timeType = isFirstDay ? '日' : this.initTimeType
      this.tidal()
    }, 1000)
    this.initBrandThrowInData()
  },
  methods: {
    getDefaultTimeType() {
      // 初始化当前时间是否为每月1号，每月1号展示品牌车辆状态统计日的数据
      const today = new Date()
      return today.getDate() === 1 ? '日' : '月'
    },
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear() // 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    getAreaBrandDetails() {
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              this.$message.warning(res.message)
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    onTimeType() {
      if (this.timeType === '年') {
        this.selectYear = this.selectYear ?? this.selectYears[0].value
      }
      this.tidal()
    },
    onSelectYear() {
      this.tidal()
    },
    explorer() {
      this.$emit('explorer', this.timeType)
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    tidal(data, id, chartName = 'chart') {
      const vm = this
      vm.dataType = vm.initDataType ? vm.initDataType : vm.dataType
      // 避免选中年份后再次选中月份，得到月份为new Date('年份')，params.month 最终为年份和默认1月数据
      const year = this.timeType === '年' ? vm.selectYear : undefined
      const format = year
        ? vm.getSiteParams(year)
        : vm.getSiteParams()
      const params = {
        selfAreaId: this.selfAreaId,
        year: format[0],
        dataType: vm.dataType
      }
      if (this.timeType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.timeType === '月') {
        params.month = format[1]
      }
      // 浮层数据获取参数
      if (data && data.time) {
        if (this.timeType === '月') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.time) < 10 ? '0' + data.time : data.time
        } else if (this.timeType === '年') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = Number(data.time) < 10 ? '0' + data.time : data.time
        }
      }
      Api.brandBikeOnline(params)
        .then((res) => {
          if (res.code === 200) {
            vm.$nextTick(() => {
              let type = '年'
              const today = new Date()
              let slicelength = 0
              if (params.year) {
                type = '年'
                if (!params.month && params.year == today.getFullYear()) {
                  slicelength = today.getMonth() + 1
                }
              }
              if (params.month) {
                type = '月'
                if (!params.day && params.month == today.getMonth() + 1) {
                  slicelength = today.getDate()
                }
              }
              if (params.day) {
                type = '日'
                if (params.day == today.getDate()) {
                  slicelength = today.getHours() + 1
                }
              }
              if (slicelength) {
                const newData = {}
                // 剔除查询当前时间为0的数据
                for (const key in res.data) {
                  // 活跃车辆
                  if (this.dataType !== '3') {
                    // 使用 reduce 方法求和
                    const sum = res.data[key].reduce((acc, obj) => {
                      return acc + obj.online_num + obj.online_num_e
                    }, 0)
                    if (sum > 0) {
                      newData[key] = res.data[key]
                    }
                  }
                }
                res.data = this.dataType === '3' ? res.data : newData
                for (const key in res.data) {
                  res.data[key] = res.data[key].slice(0, slicelength)
                }
              }
              this.chartData = res.data
              setTimeout(() => {
                this.initScale(
                  this.translateLineData(this.chartData, type),
                  id,
                  chartName
                )
              }, 1000)
            })
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const colorMap = {}
      // 过滤重复数据
      const newRealNames = [...new Set(this.realNames)]
      this.realNames = newRealNames
      for (let i = 0, len = newRealNames.length; i < len; i++) {
        const item = newRealNames[i]
        var newItem = item
        let color
        if (item.includes('(')) {
          newItem = item.slice(0, item.length - 4)
        }
        if (item.indexOf('单车') !== -1) {
          color = this.originColor(newItem) ? this.originColor(newItem) : this.color16()
        } else {
          color = this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.color16()
        }
        colorMap[item] = color
      }
      return colorMap
    },
    translateLineData(data, datatype) {
      const arr = []
      this.realNames = []
      Object.entries(data).forEach((p, idx) => {
        const key = p[0] // 品牌的名字
        for (const val of p[1]) {
          let time = ''
          let date = ''
          if (datatype === '年') {
            time = Number(val.date.split('-')[1]) + '月'
            date = Number(val.date.split('-')[1])
          } else if (datatype === '月') {
            const day = Number(val.date.split('-')[2])
            time = String(day) + '日'
            date = day
          } else if (datatype === '日') {
            time = val.hour + '点'
            date = val.hour
          }
          // 如果 7天内 第一个单车 有数值 那每天都要有数据 补全
          const dataTypeConfig = {
            1: name => name.includes('单车') ? val.online_num : val.online_num_e,
            2: name => name.includes('单车') ? val.site_num : val.site_num_e,
            3: name => name.includes('单车') ? val.active_bike_num : val.active_bike_num_e,
            4: name => name.includes('单车') ? val.dispatch_percent : val.dispatch_percent_e,
            5: name => name.includes('单车') ? val.rent_percent : val.rent_percent_e
          }
          // this.dataType 1:投放 2：入栏 3：活跃 4：调度 5：周转
          const getNum = dataTypeConfig[Number(this.dataType)]
          if (getNum) {
            const names = this.getAction(key)
            for (const name of names) {
              arr.push({
                pinpai: name,
                date: time,
                num: getNum(name),
                time: date
              })
              this.realNames.push(name)
            }
          }
        }
      })
      return arr
    },
    getAction(key) {
      const names = []
      const bpre = key.slice(0, 2)
      const epro = key
      const targetPinpai = this.brandThrowInData[key]
      const hasBike =
        targetPinpai &&
        targetPinpai.PutBikeNum + targetPinpai.BrandBikeNum > 0
      const hasEBike =
        targetPinpai &&
        targetPinpai.PutEBikeNum + targetPinpai.BrandEBikeNum > 0
      // 提取重复逻辑为函数，通过type参数区分
      const handleType = (type) => {
        if (this.isElectricBike && hasEBike) {
          if (epro === '美团出行') {
            names.push(`美团电单(${type})`)
          } else {
            names.push(`${epro}(${type})`)
          }
        }
        if (this.isBicycle && hasBike) {
          names.push(`${bpre}单车(${type})`)
        }
      }
      // 根据不同dataType调用处理函数
      if (this.dataType.includes('1')) {
        handleType('投放')
      }
      if (this.dataType.includes('2')) {
        handleType('入栏')
      }
      if (this.dataType.includes('3')) {
        handleType('活跃')
      }
      if (this.dataType.includes('4')) {
        handleType('调度')
      }
      if (this.dataType.includes('5')) {
        handleType('周转')
      }
      return names
    },
    onDataType() {
      this.tidal(null, 'totalChart', 'chart')
    },
    initScale(data, id, chartName) {
      data.sort((a, b) => {
        return a.time - b.time
      })
      // 有id表示自定义
      if (data.legnth === 0) {
        return
      }
      if (this[chartName]) {
        this[chartName].destroy()
      }
      const h = 70
      this.height = this.realHeight - h
      this[chartName] = new Line(id || 'totalChart', {
        data: data,
        height: this.realHeight - h,
        xField: 'date',
        yField: 'num',
        seriesField: 'pinpai',
        tooltip: {
          showTitle: true,
          customContent: (title, items) => {
            const sum = items.reduce((total, item) => {
              return total + item.data.num
            }, 0)
            // 数组对象去重
            const newArr = () => {
              const map = new Map()
              for (const item of items) {
                if (!map.has(item.name)) {
                  map.set(item.name, item)
                }
              }
              return [...map.values()]
            }
            const newItems = newArr()
            let itemHtml = ''
            for (const val of newItems) {
              const num = Number(val.value).toFixed(2)
              itemHtml += `<li class="g2-tooltip-list-item" >
                  <span  class="g2-tooltip-marker" style="background:${val.color}"></span>
                  <span class="g2-tooltip-name">${val.name}</span>:
                  <span class="g2-tooltip-value">${this.dataType.includes('4') || this.dataType.includes('5') ? num : val.value}</span>
                </li>`
            }
            const html =
              `<div class="g2-tooltip-title">${title} ${this.filterDataType(this.dataType, sum)}</div>
             <ul class="g2-tooltip-list">` + itemHtml + '</ul>'
            return html
          }
        },
        legend: {
          position: 'top-left',
          flipPage: false,
          itemName: {
            style: {
              fill: '#999'
            }
          }
        },
        point: {
          shape: () => {
            return 'circle'
          },
          size: 3,
          color: (datum) => {
            const colorMap = this.getColorsByNames()
            return colorMap[datum.pinpai] || this.color16() // 添加默认颜色兜底
          }
        },
        lineStyle: ({ pinpai }) => {
          // 粗的
          if (pinpai.indexOf('投放') > -1) {
            return {
              lineWidth: 3,
              lineDash: [3, 1]
            }
          } else if (pinpai.indexOf('站点') > -1) {
            return {
              lineWidth: 3
            }
          } else {
            return {
              lineWidth: 1
            }
          }
        },
        color: (datum) => {
          const colorMap = this.getColorsByNames()
          return colorMap[datum.pinpai] || this.color16() // 添加默认颜色兜底
        }
      })
      this[chartName].on('element:click', (event) => {
        // 点击数据
        if (event && event.data && event.data.data && event.data.data.num) {
          this.onClickPoint(event.data.data)
        }
      })
      this[chartName].render()
    },
    filterDataType(value, sum) {
      return {
        1: '投放车辆：' + sum,
        2: '入栏车辆：' + sum,
        3: '活跃车辆：' + sum,
        4: '调度占比：' + sum.toFixed(2),
        5: '骑行周转：' + sum.toFixed(2)
      }[Number(value)]
    },
    onClickPoint(data) {
      const vm = this
      if (this.timeType === '日') {
        // 除了月活跃点击查看日期的明细
      } else if (this.timeType === '月' && this.dataType !== '3') {
        if (data.date.slice(-1) === '日') {
          vm.dialogTitleDay =
            new Date().getFullYear() +
            '-' +
            (new Date().getMonth() + 1) +
            '-' +
            data.time +
            (vm.dark ? '曲线图' : '品牌' + this.filterDataType(this.dataType) + '曲线')
          vm.$refs.daychart.onShowDialog()
          vm.$nextTick(() => {
            vm.tidal(data, 'daychart', 'chartDays')
          })
        }
      } else if (this.timeType === '年') {
        if (data.date.slice(-1) === '月') {
          vm.monthCache = Number(data.time) < 10 ? '0' + data.time : data.time
          if (vm.selectYear) {
            vm.dialogTitleMonth =
              vm.selectYear +
              '-' +
              data.time +
              (vm.dark ? '曲线图' : '品牌' + this.filterDataType(this.dataType) + '曲线')
          } else {
            vm.dialogTitleMonth =
              new Date().getFullYear() +
              '-' +
              data.time +
              (vm.dark ? '曲线图' : '品牌' + this.filterDataType(this.dataType) + '曲线')
          }
          vm.$refs.monthchart.onShowDialog()
          vm.$nextTick(() => {
            vm.tidal(data, 'monthchart', 'chartMonths')
          })
        }
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs.monthchart.onCloseDialog()
    },
    handleCloseDay() {
      this.$refs.daychart.onCloseDialog()
    },
    initBrandThrowInData() {
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.brandPercentNew(params).then((res) => {
        if (res.code === 200) {
          this.brandThrowInData = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .title {
    display: inline-block;
  }

  .btn-group {
    float: right;

    .datatype {
      margin-left: 16px;
      display: inline-block;
      line-height: 1;
      vertical-align: middle;
    }
  }
</style>
